import { fetchContracts, getAnnouncement } from '@/shared/services/contractService'

let campaigns; let assignedAreaId

const findCampaignsWithinRange = (startDate, endDate) => campaigns.filter( campaign =>
    (!campaign.areas?.length || campaign.areas.includes(assignedAreaId)) &&
    campaign.startDate.toDate() <= startDate && endDate <= campaign.endDate.toDate()
)

const addAnnouncementToCampaign = async campaign => {
  const announcement = await getAnnouncement(campaign.announcement)
  return {
    campaignId: campaign.id,
    campaignDetails: {
      price: campaign.price, salary: campaign.salary,
      announcementId: announcement.id, title: announcement.title, summary: announcement.summary, announcementCover: announcement.cover,
    }
  }
}

const init = async (accountId, areaId, range) => { // find campaigns match the range
  assignedAreaId = areaId
  campaigns = await fetchContracts({ type: 'campaign', accountId ,range })
}

const createCampaign = async (startDate, endDate) => {
  const firstMatchedCampaign = findCampaignsWithinRange(startDate, endDate)[0]
  return firstMatchedCampaign ? addAnnouncementToCampaign(firstMatchedCampaign) : {campaignId: "", campaignDetails: {}}
}

const campaignCreator = { init, createCampaign }

export default campaignCreator